export var cors = ((window.XMLHttpRequest && 'withCredentials' in new window.XMLHttpRequest()));
export var pointerEvents = document.documentElement.style.pointerEvents === '';

export var Support = {
  cors: cors,
  pointerEvents: pointerEvents
};

export default Support;



//////////////////
// WEBPACK FOOTER
// ./node_modules/esri-leaflet/src/Support.js
// module id = 14
// module chunks = 0